import { MeasureLayout } from './MeasureLayout.mjs';

var layoutFeatures = {
    measureLayout: MeasureLayout,
};

export { layoutFeatures };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/motion/features/layout/index.mjs
// module id = ODix
// module chunks = 0